import {useState} from 'react'
import Addresses from "./Addresses";
import Orders from "./Orders";
import Profile from "./Profile";
import { useSearchParams } from "react-router-dom";

export default function AccountInfo() {

const [searchParams] = useSearchParams();
const currentTab = searchParams.get("tab");
    const tabs = [
        { label: "Profile", icon: "bi bi-person-bounding-box" },
        { label: "My Orders", icon: "bi bi-boxes" },
        { label: "Addresses", icon: "bi bi-geo-alt-fill" },
    ];

    const [activeTab, setActiveTab] = useState(currentTab ?? tabs[0].label);

    return (
        <div className="row" style={{padding:"95px 20px 10px 10px",backgroundColor:"var(--crt-9)"}}>
            <div className="col-12 col-lg-2 col-md-4 col-sm-12 p-3 pt-2">
                <div className="align-items-center gap-3 sidebar-div">
                    {
                        tabs.map((tab, index) => (
                            <div key={index} onClick={() => setActiveTab(tab.label)} className={`d-flex flex-column align-items-center sidebar-tile ${tab.label === activeTab ? 'active' : ''}`}>
                                <p>{tab.label}</p>
                                <span>
                                    <i className={tab.icon}></i>
                                </span>
                            </div>
                        ))
                    }
                </div>
            </div>
            <div className="col-12 col-lg-10 col-md-8 col-sm-12 p-1 mt-1">
                {activeTab === "Addresses" && <Addresses />}
                {activeTab === "My Orders" && <Orders />}
                {activeTab === "Profile" && <Profile setActiveTab={(e) => setActiveTab(e)} />}
            </div>
        </div>
    );
}
